<template>
  <div class="wheel-battle-team-edit">
    <div class="page-header">
      <span class="header-label">小组</span>
      <span class="header-value">{{ groupSummary }}</span>
    </div>

    <div class="section">
      <div class="section-title">出战球队</div>
      <div class="team-block">
        <draggable
          v-model="participatingTeams"
          handle=".drag-handle"
          :animation="200"
          @end="onDragEnd"
        >
          <div
            v-for="(team, index) in participatingTeams"
            :key="team.id"
            class="team-list-item"
          >
            <wheel-battle-team-row
              :team="team"
              :index="index"
              :show-index="true"
              :show-drag="true"
              :match-logo="matchLogo"
            >
              <template #action>
                <span class="delete-btn" @click="onRemoveTeam(team, index)">删除</span>
              </template>
            </wheel-battle-team-row>
          </div>
        </draggable>
        <van-empty v-if="!participatingTeams.length" description="暂无出战球队" />
      </div>
      <div class="section-tip"># 排序号码影响车轮战初赛顺序，拖住可调整。</div>
    </div>

    <div class="section candidate-section">
      <div class="section-title">候选球队</div>
      <div class="team-block">
        <div
          v-for="team in candidateTeams"
          :key="team.id"
          class="team-list-item"
        >
          <wheel-battle-team-row :team="team" :match-logo="matchLogo">
            <template #action>
              <span class="participate-btn" @click="onAddTeam(team)">出战</span>
            </template>
          </wheel-battle-team-row>
        </div>
        <van-empty v-if="!candidateTeams.length" description="暂无候选球队" />
      </div>
    </div>

    <div class="footer">
      <div class="footer-inner">
        <van-button
          type="primary"
          round
          class="save-btn"
          :loading="saving"
          @click="onSave"
        >
          保存
        </van-button>
      </div>
      <div class="footer-safe-area" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Empty, Toast } from 'vant'
import draggable from 'vuedraggable'
Vue.use(Button).use(Empty).use(Toast)

import WheelBattleTeamRow from './components/WheelBattleTeamRow.vue'
import {
  adminGetBMMatchWheelBattleParentGame,
  adminGetBMMatchStageGroupList,
  adminUpdateBMMatchStageGroupTeams
} from '@/api/wheel-battle'
import { buildTeamEditStateFromApiDetail, resolveUnassignedTeamsFromStageGroup } from '@/api/wheel-battle/adapter'
import { buildUpdateStageGroupTeamsParams } from './utils/api-params'
export default {
  name: 'WheelBattleTeamEdit',
  components: {
    WheelBattleTeamRow,
    draggable: draggable
  },
  data: function () {
    return {
      parentGameId: '',
      unionMatchId: '',
      matchId: '',
      matchLogo: '',
      stageId: '',
      groupId: '',
      groupTeamTotal: 0,
      groupName: '',
      returnTab: 'teams',
      participatingTeams: [],
      candidateTeams: [],
      saving: false
    }
  },
  computed: {
    groupSummary: function () {
      var name = this.groupName || '小组'
      return name + ' ' + this.participatingTeams.length + '支球队'
    }
  },
  mounted: function () {
    this.parentGameId = this.$route.params.parentGameId || ''
    this.unionMatchId = this.$route.query.unionMatchId || ''
    this.matchId = this.$route.query.matchId || ''
    this.groupName = this.$route.query.groupName || ''
    this.returnTab = this.$route.query.returnTab || 'teams'
    this.loadTeams()
  },
  activated: function () {
    if (this.parentGameId) {
      this.loadTeams()
    }
  },
  methods: {
    loadTeams: function () {
      var self = this
      adminGetBMMatchWheelBattleParentGame({
        gameId: self.parentGameId
      }).then(function (res) {
        if (res && res.error) {
          Toast(res.msg || '加载失败')
          return null
        }
        return res && res.data
      }).then(function (apiDetail) {
        if (!apiDetail || !apiDetail.parentGame) {
          Toast('加载失败')
          return
        }
        var pg = apiDetail.parentGame
        var matchId = self.matchId || (pg.matchId ? String(pg.matchId) : '')
        var stageId = pg.stageId ? String(pg.stageId) : ''
        if (matchId) {
          self.matchId = matchId
        }
        return adminGetBMMatchStageGroupList({
          matchId: matchId,
          stageId: stageId
        }).then(function (groupRes) {
          var stageData = groupRes && groupRes.data
          var groupTeams = resolveUnassignedTeamsFromStageGroup(stageData)
          return buildTeamEditStateFromApiDetail(apiDetail, groupTeams, stageData)
        })
      }).then(function (state) {
        if (!state) {
          return
        }
        self.participatingTeams = state.participatingTeams || []
        self.candidateTeams = state.candidateTeams || []
        self.stageId = state.stageId || self.stageId
        self.groupId = state.groupId || self.groupId
        self.groupTeamTotal = state.groupTeamTotal || 0
        if (!self.groupName && state.groupName) {
          self.groupName = state.groupName
        }
        self.matchLogo = state.unionMatchIcon || ''
      }).catch(function () {
        Toast('加载失败')
      })
    },
    onDragEnd: function () {
      // 顺序已在 v-model 中更新
    },
    onRemoveTeam: function (team, index) {
      this.participatingTeams.splice(index, 1)
      this.candidateTeams.push(Object.assign({}, team))
    },
    onAddTeam: function (team) {
      if (this.groupTeamTotal > 0 && this.participatingTeams.length >= this.groupTeamTotal) {
        Toast('出战队伍最多为 ' + this.groupTeamTotal)
        return
      }
      var idx = -1
      for (var i = 0; i < this.candidateTeams.length; i++) {
        if (this.candidateTeams[i].id === team.id) {
          idx = i
          break
        }
      }
      if (idx === -1) {
        return
      }
      var item = this.candidateTeams.splice(idx, 1)[0]
      this.participatingTeams.push(Object.assign({}, item))
    },
    onSave: function () {
      if (!this.participatingTeams.length) {
        Toast('请至少选择一支出战球队')
        return
      }
      if (!this.matchId || !this.stageId || !this.groupId) {
        Toast('缺少赛事或小组信息')
        return
      }
      if (this.groupTeamTotal > 0 && this.participatingTeams.length > this.groupTeamTotal) {
        Toast('出战队伍最多为 ' + this.groupTeamTotal)
        return
      }
      var seen = {}
      for (var i = 0; i < this.participatingTeams.length; i++) {
        var teamId = this.participatingTeams[i] && this.participatingTeams[i].id
        if (!teamId) {
          continue
        }
        if (seen[teamId]) {
          Toast('出战球队不能重复')
          return
        }
        seen[teamId] = true
      }
      var self = this
      this.saving = true
      var params = buildUpdateStageGroupTeamsParams({
        matchId: self.matchId,
        stageId: self.stageId,
        groupId: self.groupId,
        teams: self.participatingTeams
      })
      adminUpdateBMMatchStageGroupTeams(params).then(function (res) {
        self.saving = false
        if (res && res.error) {
          Toast(res.msg || '保存失败，请稍后重试')
          return
        }
        Toast.success('保存成功')
        self.$router.replace({
          path: '/match-manage/wheel-battle/parent-detail/' + self.parentGameId,
          query: {
            unionMatchId: self.unionMatchId,
            matchId: self.matchId,
            tab: self.returnTab || 'teams'
          }
        })
      }).catch(function () {
        self.saving = false
        Toast('保存失败，请稍后重试')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-team-edit {
  min-height: 100vh;
  background: #f1f1f1;
  padding-bottom: calc(64px + constant(safe-area-inset-bottom));
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #fff;
  // margin-bottom: 10px;
}

.header-label {
  font-size: 14px;
  color: #999999;
}

.header-value {
  font-size: 14px;
  color: #333;
}

.section {
  margin-bottom: 10px;
}

.section-title {
  padding: 12px 16px 8px;
  font-size: 14px;
  color: #333;
  background: #f1f1f1;
}

.team-block {
  // background: #fff;
}

.team-list-item {
  height: 50px;
}

.team-list-item + .team-list-item {
  border-top: 1px solid #f0f0f0;
}

.section-tip {
  padding: 12px 16px;
  font-size: 12px;
  color: #999999;
  line-height: 1.5;
  background: #fff;
  border-top: 1px solid #f0f0f0;
}

.candidate-section {
  margin-top: 10px;
}

.delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 28px;
  border-radius: 5px;
  background: #c45656;
  font-size: 12px;
  color: #fff;
  line-height: 1;
}

.participate-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 28px;
  border-radius: 5px;
  background: #337ecc;
  font-size: 12px;
  color: #fff;
  line-height: 1;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.06);
}

.footer-inner {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
}

.footer-safe-area {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}

.save-btn {
  min-width: 120px;
  height: 40px;
  background: #337ecc;
  border-color: #337ecc;
}
</style>
